import styled from "styled-components";
import cover from "./msa-cover.png"

const Wrapper = styled.section`
    
    background: url(${cover}) #051C2C no-repeat;
    background-position : 90% center;
    background-size : auto 80%;
    padding : 100px 0;
    h1,p{
        color : #fff;
    }
    p{
        line-height : 24px;
        opacity : 0.6;
        font-weight : light;
        font-size : 24px;
        font-family : McKinsey Sans;
    }

    h1{
        font-size : 60px;
        margin : 20px 0;
        font-family : Bower;
    }

    a,button{
        color : #fff;
        background : transparent;
        border : none;
    }

    .cover{
        max-width : 90%;
        display : flex;
        align-items : center;
        justify-content : center;
        margin : auto;
        .left{
            flex : 1;
        }
    }
`

export default Wrapper